import { commonMessages } from '../../util/messages'

export const messages = {
  common: commonMessages,
  create: {
    success: 'ISIN successfully created',
    error: 'Error creating ISIN',
  },
  update: {
    success: 'ISIN successfully updated',
    error: 'Error updating ISIN',
  },
}
